"use client";

import { SettingsMenu } from "@/components/layout/settings/SettingsMenu";
import DesktopNav from "@/components/navbar/DesktopNav";
import MobileNav from "@/components/navbar/MobileNav";
import { Button } from "@/components/ui/Button";
import { useAppContext } from "@/context/AppContext";
import { useSessionContext } from "@/context/SessionContext";
import { storePendingAuthMode } from "@/lib/auth-navigation";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Navbar() {
  const { isLoggedIn, setDoLogin } = useAppContext();
  const { isInitialLoading, setDoForgottenPassword } = useSessionContext();
  const pathname = usePathname();
  const isNewPage = pathname === "/";
  const isPortfolioPage = pathname === "/portfolio";
  const isPublicProductPage =
    isPortfolioPage || pathname === "/hlidaci-pes";
  const selectAuthMode = (login: boolean) => {
    setDoLogin(login);
    setDoForgottenPassword(false);
    storePendingAuthMode(login ? "login" : "register");
  };

  return (
    <header className="bg-background">
      <div className="desktop-header__row">
        <DesktopNav />
        {isPublicProductPage && !isLoggedIn && !isInitialLoading ? (
          <div className="desktop-nav__right-action !gap-2 sm:!gap-3">
            <Button
              asChild
              variant="outline"
              size="compact"
              className="sm:px-5"
            >
              <Link href="/#prihlaseni" onClick={() => selectAuthMode(true)}>
                Přihlášení
              </Link>
            </Button>
            <Button asChild variant="brand" size="compact" className="sm:px-5">
              <Link href="/#prihlaseni" onClick={() => selectAuthMode(false)}>
                Registrace
              </Link>
            </Button>
            <SettingsMenu switchId="desktop-guest-theme-mode" />
          </div>
        ) : isNewPage && !isLoggedIn && !isInitialLoading ? (
          <div className="desktop-nav__right-action !gap-2 sm:!gap-3">
            <Button
              asChild
              variant="outline"
              size="compact"
              className="sm:px-5"
            >
              <Link href="#prihlaseni" onClick={() => selectAuthMode(true)}>
                Přihlášení
              </Link>
            </Button>
            <Button asChild variant="brand" size="compact" className="sm:px-5">
              <Link href="#prihlaseni" onClick={() => selectAuthMode(false)}>
                Registrace
              </Link>
            </Button>
            <SettingsMenu switchId="desktop-guest-theme-mode" />
          </div>
        ) : !isInitialLoading ? (
          <SettingsMenu
            switchId={
              isLoggedIn ? "desktop-theme-mode" : "desktop-guest-theme-mode"
            }
          />
        ) : null}
      </div>
      <MobileNav />
    </header>
  );
}
